(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bluepalang-sidenav"] && !Shopify.designMode) return;
  try {
    /*
    既存テーマの開閉 JS（theme.min.js の slideNav）はトグルボタンと Esc キーしか扱わない。
    ここで補うのは次の点だけ。開閉そのものはテーマに任せる（閉じるボタンの click() を呼ぶ）。
    1. 半透明の背景をタップしたら閉じる
    2. 開いている間は背面のページをスクロールさせない
    3. 閉じたらフォーカスをハンバーガーに戻す（非表示になった × に残さない）
    4. 開いている間は Tab / Shift+Tab をサイドバー内で循環させる
    5. ハンバーガーに aria-expanded / aria-controls を付け、開閉に合わせて切り替える
    6. サイドバー内のリンクで遷移したあと、戻る（bfcache から復元）で開いたまま戻ってきたら閉じる
    テーマエディタでヘッダーが再描画されても動くよう、要素は毎回取り直す
  */
  (function () {
    var OPEN_CLASS = 'js-menu--is-open'; // テーマ側の状態クラス
    var LOCK_CLASS = 'bluepalang-sidenav-is-locked';
    var TOGGLE_SELECTOR = '.js-toggle-slide-nav'; // テーマ側の開閉フック
    var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var observer = null;
    var wasOpen = false;

    function getOverlay() {
      return document.querySelector('[data-bluepalang-sidenav-overlay]');
    }

    function isOpenNow(overlay) {
      return !!overlay && overlay.classList.contains(OPEN_CLASS);
    }

    // サイドバーの外にある開閉ボタン（ハンバーガー。ヘッダー・追従カートなど複数ありうる）
    function getOpeners(overlay) {
      return Array.prototype.filter.call(document.querySelectorAll(TOGGLE_SELECTOR), function (el) {
        return !overlay.contains(el);
      });
    }

    function updateOpeners(overlay, isOpen) {
      var nav = overlay.querySelector('[data-bluepalang-sidenav]');
      getOpeners(overlay).forEach(function (el) {
        el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (nav && nav.id) { el.setAttribute('aria-controls', nav.id); }
      });
    }

    // 画面に出ている操作可能な要素だけ（閉じた details の中身や非表示の要素は除く）
    function getFocusables(overlay) {
      var nav = overlay.querySelector('[data-bluepalang-sidenav]');
      if (!nav) { return []; }
      return Array.prototype.filter.call(nav.querySelectorAll(FOCUSABLE_SELECTOR), function (el) {
        return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
      });
    }

    function sync() {
      var overlay = getOverlay();
      var isOpen = isOpenNow(overlay);
      document.documentElement.classList.toggle(LOCK_CLASS, isOpen);
      if (overlay) { updateOpeners(overlay, isOpen); }

      if (wasOpen && !isOpen && overlay && overlay.contains(document.activeElement)) {
        var opener = getOpeners(overlay).find(function (el) {
          return el.offsetParent !== null;
        });
        if (opener) { opener.focus(); }
      }
      wasOpen = isOpen;
    }

    function watch() {
      if (observer) { observer.disconnect(); }
      var overlay = getOverlay();
      if (!overlay) {
        // テーマエディタで新サイドバーをオフにすると、開いたままの状態で要素ごと消える。スクロール固定を残さない
        document.documentElement.classList.remove(LOCK_CLASS);
        wasOpen = false;
        return;
      }
      observer = new MutationObserver(sync);
      observer.observe(overlay, { attributes: true, attributeFilter: ['class'] });
      sync();
    }

    function close(overlay) {
      var closeButton = overlay.querySelector('[data-bluepalang-sidenav-close]');
      if (closeButton) { closeButton.click(); }
    }

    // 背景は SP では overlay 要素そのもの、PC では body 側に描かれる。それ以外のクリックでは閉じない
    document.addEventListener('click', function (event) {
      var overlay = getOverlay();
      if (!isOpenNow(overlay)) { return; }
      if (event.target !== overlay && event.target !== document.body) { return; }
      close(overlay);
    });

    // フォーカスの循環。開いた直後はテーマが overlay 自体にフォーカスを置くので、そこからも内側へ入れる
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) { return; }
      var overlay = getOverlay();
      if (!isOpenNow(overlay)) { return; }
      var focusables = getFocusables(overlay);
      if (focusables.length === 0) { return; }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;
      var inside = focusables.indexOf(active) !== -1;

      if (event.shiftKey && (active === first || !inside)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !inside)) {
        event.preventDefault();
        first.focus();
      }
    });

    // 戻るで bfcache から復元されたとき、開いたままなら閉じる。閉じていてもスクロール固定は外す
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) { return; }
      var overlay = getOverlay();
      if (isOpenNow(overlay)) { close(overlay); }
      sync();
    });

    document.addEventListener('shopify:section:load', watch);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
